import { render, staticRenderFns } from "./CardTypeNum.vue?vue&type=template&id=1dd41e5f&scoped=true"
import script from "./CardTypeNum.vue?vue&type=script&lang=js"
export * from "./CardTypeNum.vue?vue&type=script&lang=js"
import style0 from "./CardTypeNum.vue?vue&type=style&index=0&id=1dd41e5f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd41e5f",
  null
  
)

export default component.exports